'use strict';

const getBuyUrlWithShippingOptionData = (buyUrl, shippingOptionData = {}) => {
  const params = Object.keys(shippingOptionData).reduce((paramList, key) => {
    const value = shippingOptionData[key];
    if (value) {
      paramList.push(`${key}=${value}`);
    }
    return paramList;
  }, []);

  return `${buyUrl}${buyUrl.indexOf('?') > -1 ? '&' : '?'}${params.join('&')}`;
};

module.exports = getBuyUrlWithShippingOptionData;
